import { render, staticRenderFns } from "./booking_customer_details.vue?vue&type=template&id=aefbb3ce&scoped=true&"
import script from "../assets/js/booking_customer_details.js?vue&type=script&lang=js&"
export * from "../assets/js/booking_customer_details.js?vue&type=script&lang=js&"
import style0 from "./booking_customer_details.vue?vue&type=style&index=0&id=aefbb3ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefbb3ce",
  null
  
)

export default component.exports